import React, { Component } from 'react';
/** 定义属性对象
 * - showoverlay: 是否显示遮罩
 * - children: 子组件
 */
type Props = {
    children?: React.ReactNode;
    showoverlay: boolean;
};

const css: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: 1000,
    background: 'rgba(43, 43, 43, 0.4)',
    backdropFilter: 'blur(10px)',
    mixBlendMode: 'normal',
};

export default class MiniShade extends Component<Props> {
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    render() {
        const { showoverlay, children } = this.props;
        return <>{showoverlay ? <div style={css}>{children}</div> : null}</>;
    }
}
